import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import HubPerformanceHeader from './HubPerformanceHeader';
import HubPerformanceData from './HubPerformanceData';
import Loading from '../Loading';
import { Helmet } from 'react-helmet';

const base = 'performance';

@inject('HubPerformanceStore')
@observer
class HubPerformance extends Component {
    componentDidMount() {
        const {
            HubPerformanceStore: { handleGetPerformanceData },
        } = this.props;

        handleGetPerformanceData();
    }

    render() {
        const { HubPerformanceStore } = this.props;
        const { loading, targetsLoading, stockLoading, targetError } = HubPerformanceStore;

        if (loading) {
            return <Loading />;
        }

        return (
            <Fragment>
                <Helmet>
                    <title>Outlet Performance</title>
                </Helmet>
                <HubPerformanceHeader />
                <div className={`${base}__container container mtxl mbxl`}>
                    {(targetsLoading || stockLoading) && (
                        <p className={`${base}__refreshing`}>Refreshing performance data…</p>
                    )}
                    {targetError && (
                        <p className={`${base}__warning`}>
                            Sales targets are temporarily unavailable: {targetError}
                        </p>
                    )}
                    <HubPerformanceData />
                </div>
            </Fragment>
        );
    }
}

export default HubPerformance;
